import React from 'react';

import { useAppDispatch, useAppSelector } from 'store';

import { setConfirmationModal, useConfirmBackNavigation } from 'modules/global';

import { QuestionTypeEnum } from '../constants';
import { useProgressTest } from '../hooks';

import ComplexWithSubsTest from './complex-with-subs-test';
import ExclusiveSubsTest from './exclusive-subs-test';
import FinishConfirmModal from './finish-confirm-modal';
import Header from './header';
import InputTest from './input-test';
import SimpleQuestion from './simple-test';
import { TestSkeleton } from './skeleton';

export const Main = () => {
  const dispatch = useAppDispatch();
  const { isLoading } = useProgressTest();
  const testData = useAppSelector(({ nationalCertificate }) => nationalCertificate.test);

  useConfirmBackNavigation(() => {
    dispatch(setConfirmationModal(true));
  });

  const componentsMap = {
    simple: SimpleQuestion,
    complex_with_input: InputTest,
    complex_with_subs: ComplexWithSubsTest,
    exclusive_subs: ExclusiveSubsTest
  };

  if (isLoading && !testData) {
    return <TestSkeleton />;
  }

  return (
    <>
      <div className="my-10 lg:space-y-5">
        {testData && <Header />}
        <div className='space-y-5'>
          {testData?.test?.questions.map(question => {
            const Component = componentsMap[question.type as QuestionTypeEnum];

            return Component ? <Component key={question.question_id} data={question} /> : null;
          })}
        </div>
      </div>

      <FinishConfirmModal ticketId={testData?.ticket_id} />
    </>
  );
};
